import { useEffect, useState } from "react";
import { collectionData } from "rxfire/firestore";
import { combineLatest } from "rxjs";

import { WithId } from "../types/typeHelpers";

interface UseCollectionSubscriberParams {
  queries: firebase.firestore.Query[];
  idField?: string;
  deps?: Array<any>;
}

function useCollectionSubscriber<T>({
  queries,
  idField = "id",
  deps = [],
}: UseCollectionSubscriberParams) {
  const [documents, setDocuments] = useState<WithId<T>[]>([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const subscribeToPublisherCollection = () => {
    setLoading(true);
    const getDocuments$ = combineLatest(
      queries.map((query) => collectionData<WithId<T>>(query, idField))
    );
    const subscription = getDocuments$.subscribe(
      (observedDocuments) => {
        setLoading(false);
        return setDocuments(observedDocuments.flat());
      },
      (err: any) => {
        setLoading(false);
        setError(err);
      }
    );
    return () => subscription.unsubscribe();
  };
  useEffect(subscribeToPublisherCollection, deps);
  return { documents, error, loading };
}

export default useCollectionSubscriber;
